import React from 'react';
import { motion } from 'framer-motion';
import { loanHeader, seasoningReasons } from '../../data/withdraw';
import { reasonIcons } from '../../data/reasonMeta';
import { SeasoningForm } from '../../types/withdraw';
import { inputClasses, popSpring } from '../../utils/styles';
import { Expand } from '../ui/Expand';
import { FormField } from '../ui/FormField';
import { CadencePreview } from './CadencePreview';
import { SeasoningReasonFields } from './SeasoningReasonFields';
interface SeasoningPathStepProps {
  form: SeasoningForm;
  onChange: (patch: Partial<SeasoningForm>) => void;
}
export function SeasoningPathStep({
  form,
  onChange
}: SeasoningPathStepProps) {
  const firstName = loanHeader.borrower.split(' ')[0];
  const selected = seasoningReasons.find(r => r.id === form.reason);
  return <div className="space-y-6" data-id="element-169" data-mp="3gxwgs0sq6kdx">
      <div data-id="element-170" data-mp="3gxmq0azuw976">
        <h3 className="text-lg font-bold tracking-tight text-slate-900" data-id="element-171" data-mp="3h10pnbh4y4ax">Why is {firstName}'s loan seasoning?</h3>
        <p className="mt-1 text-sm text-slate-500" data-id="element-172" data-mp="3nmfo6my1bq32">We'll only ask for what's needed to know when it's workable again.</p>
      </div>

      <div role="radiogroup" aria-label="Seasoning reason" className="flex flex-wrap gap-2" data-id="element-173" data-mp="3io4fwgne1nmy">
        {seasoningReasons.map(r => {
        const Icon = reasonIcons[r.id];
        const isSel = form.reason === r.id;
        return <motion.button key={r.id} type="button" role="radio" aria-checked={isSel} onClick={() => onChange({
          reason: r.id
        })} animate={{
          scale: isSel ? 1.04 : 1
        }} whileTap={{
          scale: 0.97
        }} transition={popSpring} className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 text-sm font-semibold transition-[background-color,border-color,color,box-shadow] duration-150 ease-out-soft focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary-100 ${isSel ? 'border-primary-700 bg-primary-700 text-white shadow-[0_8px_18px_-8px_rgba(15,118,110,0.6)]' : 'border-slate-200 bg-white text-slate-700 hover:border-primary-200 hover:bg-primary-50 hover:text-primary-800'}`} data-id="element-174" data-mp="3snlhalvlxfd4">
              <Icon className="h-4 w-4" aria-hidden="true" data-id="element-175" data-mp="1awwa0yccpzq4" />
              {r.id}
            </motion.button>;
      })}
      </div>

      <Expand show={Boolean(form.reason)} id={form.reason || 'none'} data-id="element-176" data-mp="1exojnsp4y6mx">
        <div className="rounded-2xl border border-slate-200 bg-slate-50/70 p-5" data-id="element-177" data-mp="1jx1h17dmuw3r">
          {selected && <p className="mb-4 text-sm text-slate-600" data-id="element-178" data-mp="1owxd8kg39j8r">{selected.description}</p>}
          <SeasoningReasonFields form={form} onChange={onChange} data-id="element-179" data-mp="1out51qb5py2o" />
        </div>
      </Expand>

      <div className="grid gap-4 sm:grid-cols-[1.5fr_1fr] sm:items-start" data-id="element-180" data-mp="1tte8rzpmazvv">
        <CadencePreview cadence={form.cadence} onChange={cadence => onChange({
        cadence
      })} data-id="element-181" data-mp="3qpv96p55wrxx" />
        <FormField label="Suspended until" htmlFor="suspended-until" required hint="Hidden from the active pipeline until this date." data-id="element-182" data-mp="3vnn8i484zgc5">
          <input id="suspended-until" type="date" value={form.suspendedUntil} onChange={e => onChange({
          suspendedUntil: e.target.value
        })} className={inputClasses} data-id="element-183" data-mp="281al9pf62hcd" />
        </FormField>
      </div>
    </div>;
}